// Maintenance banner component
export function maintenance() {
  return {
    showBanner: false,
    maintenanceMessage: 'En mantenimiento, vuelve más tarde',
    dismissed: false,

    init() {
      // Check if banner was dismissed in this session
      this.dismissed = sessionStorage.getItem('maintenance-dismissed') === 'true';
      
      // Check for maintenance status on component initialization
      this.checkMaintenanceStatus();
      
      // Check again when user data is loaded
      this.$watch('$store.app.user', () => {
        if (this.$store.app.user) {
          this.checkMaintenanceStatus();
        }
      });
    },

    checkMaintenanceStatus() {
      // Check if maintenance is enabled from user profile or health endpoint
      const user = this.$store.app.user;
      if (user && user.maintenance) {
        this.updateMaintenanceStatus(user.maintenance);
      } else {
        // Fallback: check health endpoint
        this.fetchMaintenanceStatus();
      }
    },

    async fetchMaintenanceStatus() {
      try {
        // Use direct URL to avoid API construction issues
        const apiUrl = 'https://destiny-reborn.onrender.com/api/public/config';
        const response = await fetch(apiUrl + '?t=' + Date.now()); // Cache bust
        
        if (!response.ok) {
          console.warn('Maintenance check failed:', response.status);
          return;
        }
        
        const data = await response.json();
        
        // Check maintenance from public config - ensure it's explicitly false to hide banner
        if (data.maintenance === false) {
          this.updateMaintenanceStatus({ enabled: false });
        } else if (data.maintenance === true) {
          this.updateMaintenanceStatus({
            enabled: true,
            message: data.message || 'En mantenimiento, vuelve más tarde'
          });
        }
      } catch (error) {
        console.warn('Failed to check maintenance status:', error);
        // On error, don't show banner - be conservative
        this.updateMaintenanceStatus({ enabled: false });
      }
    },

    updateMaintenanceStatus(maintenance) {
      // Force hide banner if maintenance is explicitly disabled
      if (maintenance && maintenance.enabled === false) {
        this.showBanner = false;
        return;
      }
      
      // Show banner only if maintenance is enabled and not dismissed
      if (maintenance && maintenance.enabled === true && !this.dismissed) {
        this.maintenanceMessage = maintenance.message || 'En mantenimiento, vuelve más tarde';
        this.showBanner = true;
      } else {
        this.showBanner = false;
      }
    },

    dismissBanner() {
      this.dismissed = true;
      this.showBanner = false;
      
      // Store dismissal in sessionStorage so it doesn't show again this session
      sessionStorage.setItem('maintenance-dismissed', 'true');
    },

    // Method to reset dismissal (useful for testing or when maintenance status changes)
    resetDismissal() {
      this.dismissed = false;
      sessionStorage.removeItem('maintenance-dismissed');
    },

    // Force refresh maintenance status (bypasses all cache)
    async forceRefresh() {
      this.dismissed = false;
      sessionStorage.removeItem('maintenance-dismissed');
      await this.fetchMaintenanceStatus();
    }
  };
}

// Global maintenance utility functions
window.maintenanceUtils = {
  // Check if banner was dismissed in this session
  wasDismissed() {
    return sessionStorage.getItem('maintenance-dismissed') === 'true';
  },
  
  // Clear dismissal status
  clearDismissal() {
    sessionStorage.removeItem('maintenance-dismissed');
  },

  // Force check maintenance status (for debugging/admin)
  async forceCheck() {
    try {
      const response = await fetch('https://destiny-reborn.onrender.com/api/public/config?t=' + Date.now());
      const data = await response.json();
      console.log('Maintenance status:', data.maintenance);
      console.log('Message:', data.message);
      return data;
    } catch (error) {
      console.error('Failed to check maintenance:', error);
      return null;
    }
  }
};